<script>
    export let data = {};

    // components
    import Button from "./../Button.svelte";
    import DisclosureCard from "../DisclosureCard.svelte";
    import HorizontalRule from "./../presentational/HorizontalRule.svelte";
    import View from "../presentational/View.svelte";
    import VPNAlphaLogo from "./../presentational/logos/VPNAlphaLogo.svelte";
    import VPNDevice from "./VPNDevice.svelte";

    // functions
    import { createEventDispatcher } from "svelte";
    import { updateDevice, deleteDevice } from "../../api/client.js";

    import { getOSSingleChar } from "../../utilities/platforms.js";

    $: devices = data && data.product && data.product.options && data.product.options.devices && Object.keys(data.product.options.devices)
        .map((key) => data.product.options.devices[key])
        .sort((a, b) => new Date(b.last) - new Date(a.last)) || [];

    const dispatch = createEventDispatcher();

    const handleUpdateDevice = ({ device_id, name }) => {
        updateDevice({
            device_id,
            dataToUpdate: { name },
            onSuccess: function () {
                // TODO maybe make thie cleaner
                dispatch("message", {
                    action: "STATE_UPDATED",
                    data: {},
                });
            },
            onError: function (err) {
                console.log("update device error", err);
            },
        });
    };

    const handleDeleteDevice = ({ device_id }) => {
        deleteDevice({
            device_id,
            onSuccess: () => (devices = devices.filter((d) => d.device_id !== device_id)),
            onError: (err) => console.log("delete device error", err),
        });
    };

    const handleMessage = (msg) => {
        switch (msg.detail.action) {
            case "UPDATE":
                handleUpdateDevice(msg.detail.data);
                break;
            case "DELETE":
                handleDeleteDevice(msg.detail.data);
                break;
            default:
                console.log("default handleMessage", msg);
                break;
        }
    };

    const osToURL = {
        W: "https://dl.adblock.dev/windows/vpn/AdBlockVPN.exe",
        I: "https://testflight.apple.com/join/YoIlotDH",
        A: "https://play.google.com/store/apps/details?id=com.adblock.vpn",
        M: "https://dl.adblock.dev/mac/vpn/AdBlockVPN.dmg",
    };
    function handleDownloadButtonClick() {
        // get URL for download
        const downloadURL = osToURL[getOSSingleChar()];
        if (downloadURL === null || typeof downloadURL === "undefined") {
            window.alert("We don't have a download available for your platform just yet. Please check back soon!");
            return
        }
        window.location.href = downloadURL;
    }

    const osSingle = getOSSingleChar();
    // True for the most part.
    const isSupported = osSingle !== "L";

    import { t } from "../../i18n";
</script>

<DisclosureCard logoComponent="{VPNAlphaLogo}" isActive="{true}" collapsedDescription="Alpha User" expandedDescription="Alpha User" on:message>
    <div class="row">
        <View viewType="{'card-wrap'}">
            <h3>{$t('active_devices')}</h3>
            {#if devices.length > 0}
                <HorizontalRule />
            {/if}
            <div class="row">
                {#each devices as d, idx (d.device_id)}
                    <!-- 
                    (d.device_id) is a key so we can uniquely identify each item in the each block.
                    https://svelte.dev/tutorial/keyed-each-blocks -->
                    <!-- d like: { created: "2020-01-01T12:12:12.000Z", device_id: "did1",
                        last: "2020-01-01T12:12:12.000Z", modified: "2020-01-01T12:12:12.000Z", name: "Iain's MacBook"}
                    -->
                    {#if idx !== devices.length - 1}
                        <VPNDevice data="{d}" on:message="{handleMessage}" classNames="{'underline'}" />
                    {:else}
                        <VPNDevice
                            data="{d}"
                            on:message="{handleMessage}"
                            classNames="{'underline-dark'}"
                        />
                    {/if}
                {/each}
            </div>
            <div class="device-ct row justify-content-flex-end">
                {$t('number_devices_connected', {"$currentDeviceCount$": devices.length, "$maximumDeviceCount$": 6})}
            </div>
        </View>
    </div>
    <div class="v-8-px"></div>
    <HorizontalRule />
    <div class="v-8-px"></div>
    <div class="not-supported row align-items-center collapse-to-col">
        {#if !isSupported}
            <i class="material-icons-outlined not-supported">error_outline</i>
            <span class="not-supported">VPN is currently available for Mac OS, Windows, iOS, and Android</span>
        {:else}
            <Button
                buttonText="{'Download'}"
                classNames="{'far-right-auto short w176px'}"
                on:click="{handleDownloadButtonClick}"
            />
        {/if}
    </div>
</DisclosureCard>

<style>
    i:hover {
        color: inherit;
    }
    i.not-supported {
        cursor: unset;
    }
    span.not-supported {
        margin-left: 16px;
        color: var(--textColorDarkest);
    }
    div.device-ct {
        margin-top: 16px;
    }
    div.v-8-px {
        width: 100%;
        margin: 8px 0px;
    }
</style>
